export default function AssetPickerEditOption({ onClick, title, src, height = '10px', style }) {
  return (
    <img
      onClick={onClick}
      data-tooltip-id="asset-picker"
      data-tooltip-content={title}
      src={src}
      height={height}
      style={style}
    />
  );
}
